export const api = (url, options = {}) =>
  new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    if (token && token !== '') {
      if (!options.headers) {
        options.headers = {};
      }

      if (!options.headers.authorization) {
        options.headers.authorization = token;
      }
    }
    fetch(url, options)
      .catch((err) => {
        if (err?.status === 409) {
          reject(err);
        }
        reject(err);
        return;
      })
      .then((res) => {
        if (res?.status === 409) {
          reject(res);
        }
        resolve(res);
        return;
      });
  });
